import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ActualityPage from './pages/ActualityPage';
import ProjectPage from './pages/ProjectPage';
import AboutPage from './pages/AboutPage';
import WaterCommissionPage from './pages/WaterCommissionPage';
import ContactPage from './pages/ContactPage';
import Layout from './components/Layout';
import './App.css';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/actualites" element={<ActualityPage />} />
          <Route path="/projets" element={<ProjectPage />} />
          <Route path="/apropos" element={<AboutPage />} />
          <Route path="/apropos/commission-eau" element={<WaterCommissionPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Route>
      </Routes>
    </Router>
  );
}